/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Allow_All_DescriptionInputs */



/**
* | output |
* | --- |
* | "Under this posture every tool the connector exposes is available. Switch to “Only enabled tools” to restrict access — the rows below then take effect." |
*
* @param {Rights_Tools_Allow_All_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_allow_all_description = /** @type {((inputs?: Rights_Tools_Allow_All_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Allow_All_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei dieser Positur ist jedes vom Connector bereitgestellte Tool verfügbar. Wechseln Sie zu „Nur freigegebene Tools“, um den Zugriff einzuschränken – die Zeilen unten werden dann wirksam.")
	return /** @type {LocalizedString} */ ("Under this posture every tool the connector exposes is available. Switch to “Only enabled tools” to restrict access — the rows below then take effect.")
});